module.exports = __webpack_public_path__ + "img/fille_casque.86cd6efa.png";